import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "117110cf-d6ac-4f4d-8d36-3da53cdd52d2",
    content: "0.2 m x 0.4 m",
    options: {},
  },
  {
    id: "f4a620da-fafd-4e09-a372-27cc9694f28d",
    content: "Outlet with a cross-section of 0.12 m<sup>2</sup>",
    options: {},
  },
  {
    id: "bfe270c0-3718-4957-a387-91e5ead76141",
    content: "0.2 m x 0.2 m",
    options: {},
  },
  {
    id: "d1e01235-a4b2-41bb-94e9-163ebcb7ab3d",
    content: "All proposed solutions are incorrect",
    options: {},
  },
];

export const task: Task = {
  id: "84f0440b-3cac-4fea-8051-a74ef96d314b",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    shuffle: true,
    columns: 1,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["117110cf-d6ac-4f4d-8d36-3da53cdd52d2", "f4a620da-fafd-4e09-a372-27cc9694f28d"],
};
